/* eslint-disable import/prefer-default-export */
import { motion } from 'framer-motion'
import styled from 'styled-components'
import { accent, background2 } from '../../../Styles/colors'
import { hFlex, square, vFlex } from '../../../Styles/style-helpers'

export const UpcomingClassEl = styled(motion.div)`
  display: block;
  height: calc(100% - 1em);
  width: 15rem;
  ${hFlex};
  padding: 0 1em;
  margin: 0.5em 0;

  .content {
    background: ${background2};
    height: 100%;
    width: 100%;
    ${vFlex};
    justify-content: flex-start;
    border-radius: 0.5em;

    .cover {
      ${square('11.5rem')};
      margin: 1em 0;
      background: #333;
      border-radius: 0.25em;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    p {
      padding: 0 1em;
      width: 100%;
      font-weight: bold;
      line-height: 1.33;

      &.artist {
        font-weight: normal;
        margin: 0.5em 0 2em;

        span {
          font-weight: bold;
          color: ${accent};
        }
      }

      &.startTime {
        font-weight: normal;
      }
    }
  }
`
